<div class="email-sent-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Reset Password</span
      >
    </nav>
  </header>

  <mat-card class="email-sent-card" appearance="outlined">
    <mat-card-content>
      <h1 class="email-sent-card__heading">Check your email</h1>

      <p class="email-sent-card__body">
        If an account exists for this email address, we've sent you a link to reset your password.
        Please check your inbox and spam folder.
      </p>

      @if (sentEmail()) {
        <p class="email-sent-card__sent-to">
          Sent to: <strong>{{ sentEmail() }}</strong>
        </p>
      }

      @if (resendState() === 'sent') {
        <span class="resend-confirmation">Check your inbox — another email may be on its way.</span>
      } @else {
        <button
          type="button"
          mat-stroked-button
          class="full-width"
          [disabled]="resendState() === 'loading'"
          (click)="onResend()"
        >
          @if (resendState() === 'loading') {
            <mat-spinner diameter="20" />
          } @else {
            Resend Email
          }
        </button>
      }

      <p class="email-sent-card__note">Didn't receive anything? It may take a few minutes.</p>

      <div class="or-divider" aria-hidden="true">
        <span class="or-divider__line"></span>
      </div>

      <a [routerLink]="['/auth/login']" class="support-link">Back to Login</a>
    </mat-card-content>
  </mat-card>
</div>
